/** Asynchronously loads the component for AuthExchange page. */
import { lazyLoad } from "utils/loadable";

export const AuthExchange = lazyLoad(
  () => import("./index"),
  (module) => module.AuthExchange,
);
